import { NavigationGuardNext, Route } from 'vue-router';
import store from '@/store';
import authType from '@/store/types/auth';
import { NemipayNotifications } from '@/util/nemipayNotifications';
import { validateCredentials } from '@/util/credentials';
import i18n from '@/i18n';
export function checkMasspaymentCredentials(
  to: Route,
  from: Route,
  next: NavigationGuardNext<Vue>,
  customMsg?: { title?: string; message?: string }
): void {
  const masspaymentCredentials = store.getters[`authModule/${authType.getters.GET_MASSPAYMENT_CREDENTIALS}`];

  const notification = new NemipayNotifications();

  if (!validateCredentials(masspaymentCredentials)) {
    const title = customMsg?.title || i18n.t('credentials.validation.masspaymentRequired') as string;
    const message = customMsg?.message || i18n.t('credentials.validation.masspaymentRequiredMsg') as string;

    notification.warning(title, message);
    next(false);
    return;
  }

  next();
}
